/**
 * The native shell scrolls inside .app-scroll, not the window.
 * Reset both so a screen change does not keep a previous pan or offset.
 */
export function resetAppScroll() {
  window.scrollTo(0, 0);
  const root = document.scrollingElement || document.documentElement;
  if (root) {
    root.scrollTop = 0;
    root.scrollLeft = 0;
  }
  document.documentElement.scrollTop = 0;
  document.documentElement.scrollLeft = 0;
  if (document.body) {
    document.body.scrollTop = 0;
    document.body.scrollLeft = 0;
  }
  document.querySelectorAll('.app-scroll').forEach((node) => {
    node.scrollTop = 0;
    node.scrollLeft = 0;
  });
}

/** After a scroll reset, honor /terms#vendor-submissions and other legal hashes. */
export function scrollToLocationHash() {
  if (typeof window === 'undefined' || !window.location) return;
  const raw = String(window.location.hash || '').replace(/^#/, '');
  if (!raw) return;
  let id = raw;
  try {
    id = decodeURIComponent(raw);
  } catch {
    id = raw;
  }
  const node = document.getElementById(id);
  if (node && typeof node.scrollIntoView === 'function') {
    node.scrollIntoView({ block: 'start' });
  }
}
